import React from 'react';
import { Wrapper } from './styles';

type StepperPointProps = {
  number: number;
  focused: boolean;
  complete: boolean;
};

export const StepperPoint: React.FC<StepperPointProps> = ({ number, focused, complete }) => {
  return (
    <Wrapper focused={focused} complete={complete}>
      {number}
    </Wrapper>
  );
};
